import React, { useEffect } from 'react';
import { BrowserRouter, Switch, Redirect } from 'react-router-dom';
import Admin from './Admin';
import User from './User';
import Starter from './Starter/Starter';
import ErrorNotifier from '../Components/ErrorNotifier/ErrorNotifier';
import { useAuth0 } from '../react-auth0-spa';
import PrivateRoute from '../Components/PrivateRoute/PrivateRoute';
import { LocaleProvider } from 'antd';
import PL from 'antd/lib/locale-provider/pl_PL';
import moment from 'moment';
import 'moment/locale/pl';
import { useDispatch, useSelector } from 'react-redux';
import { REQUEST_GET_AUTH_USER_DATA } from '../Redux/constants/constants';

moment.locale('pl');

const App = () => {
  const { isAuthenticated, loginWithRedirect, user, loading } = useAuth0();
  const dispatch = useDispatch();
  const authUserData = useSelector((state) => state.authenticatedUserData);

  useEffect(() => {
    if (user) {
      dispatch({
        type: REQUEST_GET_AUTH_USER_DATA,
        payload: user.email,
      });
    }
    if (isAuthenticated === false) {
      loginWithRedirect({});
    }
  }, [user, isAuthenticated]);

  if (loading || authUserData === null) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <BrowserRouter>
        <ErrorNotifier />
        <LocaleProvider locale={PL}>
          {/*{!isAuthenticated && (*/}
          {/*  <div style={{ marginTop: '200px', height: '60vh' }}>*/}
          {/*    <Row type="flex" justify="center">*/}
          {/*      <Col xs={22} md={16} xl={6}>*/}
          {/*        <div>*/}
          {/*          <img*/}
          {/*            src={logoWithText}*/}
          {/*            style={{ maxWidth: '100%', maxHeight: '100%' }}*/}
          {/*          />*/}
          {/*        </div>*/}
          {/*      </Col>*/}
          {/*    </Row>*/}
          {/*    <Row type="flex" justify="center">*/}
          {/*      <Col*/}
          {/*        xs={12}*/}
          {/*        md={4}*/}
          {/*        xl={2}*/}
          {/*        style={{*/}
          {/*          display: 'flex',*/}
          {/*          alignItems: 'center',*/}
          {/*          justifyContent: 'center'*/}
          {/*        }}*/}
          {/*      >*/}
          {/*        <Button*/}
          {/*          style={{*/}
          {/*            marginTop: '36px',*/}
          {/*            width: '100px'*/}
          {/*          }}*/}
          {/*          size={'large'}*/}
          {/*          type={'link'}*/}
          {/*          onClick={() => loginWithRedirect({})}*/}
          {/*        >*/}
          {/*          Zaloguj*/}
          {/*        </Button>*/}
          {/*      </Col>*/}
          {/*    </Row>*/}
          {/*    <Row type="flex" justify="center">*/}
          {/*      <Col*/}
          {/*        xs={12}*/}
          {/*        md={4}*/}
          {/*        xl={2}*/}
          {/*        style={{*/}
          {/*          display: 'flex',*/}
          {/*          alignItems: 'center',*/}
          {/*          justifyContent: 'center'*/}
          {/*        }}*/}
          {/*      >*/}
          {/*        <Button*/}
          {/*          style={{*/}
          {/*            marginTop: '36px',*/}
          {/*            width: '140px'*/}
          {/*          }}*/}
          {/*          size={'large'}*/}
          {/*          type={'primary'}*/}
          {/*          onClick={() => loginWithRedirect({ screen_hint: 'signup' })}*/}
          {/*        >*/}
          {/*          Załóż konto*/}
          {/*        </Button>*/}
          {/*      </Col>*/}
          {/*    </Row>*/}
          {/*  </div>*/}
          {/*)}*/}

          {isAuthenticated && authUserData === 'no user' && (
            <>
              <Redirect
                to={{
                  pathname: '/starter',
                }}
              />
            </>
          )}
          {isAuthenticated &&
            authUserData &&
            authUserData !== 'no user' &&
            authUserData.role === 'user' && (
              <>
                <Redirect
                  to={{
                    pathname: '/user/timesheet',
                  }}
                />
              </>
            )}
          {isAuthenticated &&
            authUserData &&
            authUserData !== 'no user' &&
            authUserData.role !== 'user' && (
              <>
                <Redirect
                  to={{
                    pathname: '/admin/projects',
                  }}
                />
              </>
            )}
          <Switch>
            <PrivateRoute path="/admin" component={Admin} />
            <PrivateRoute path="/user" component={User} />
            <PrivateRoute path="/starter" component={Starter} />
          </Switch>
        </LocaleProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
